<template>
  <draft v-model="active" :route="route" />
</template>

<script>
import draft from "@/views/components/order/draft/draft.vue";
import { mixinCheckOrder } from "@/views/bsg/components/checkOrder/index.js";
export default {
  mixins: [mixinCheckOrder],
  components: {
    draft,
  },
  data() {
    return {
      active: "/bsg/otd/draft", //当前激活页
      route: {
        order: "/bsg/otd/order",
        draft: "/bsg/otd/draft",
        history: "",
      },
    };
  },
  created() {
    this.handleCheckOrder();
  },
};
</script>
